__turbopack_context__.v({
  "formLinkContainer": "LoginModal-module__-wZeKq__formLinkContainer",
  "imageWrapper": "LoginModal-module__-wZeKq__imageWrapper",
  "line": "LoginModal-module__-wZeKq__line",
});
